import { RootState } from "../../../../../redux/store";
import { useSelector } from "react-redux";
import { CustomChip } from "../../../../global/chips/CustomChip";
import { ListingDetailsContentWrapper } from "./ListingDetailsContentWrapper";
import { ListingDetailsContentHeader } from "./ListingDetailsContentHeader";
import { TitleLargeProminent } from "../../../../global/ui/typography";
import { ListingDetailsChipsWrapper } from "./ListingDetailsChipsWrapper";
import { ListingDetailsContentViewer } from "./ListingDetailsContentViewer";

export const ListingDetailsContent = () => {
  const trainingPlanRedux = useSelector(
    (state: RootState) => state.trainingPlan.listingData,
  );

  return (
    <ListingDetailsContentWrapper>
      <ListingDetailsContentHeader>
        <TitleLargeProminent>Details</TitleLargeProminent>

        {trainingPlanRedux.trainingPlan && !trainingPlanRedux.publicListing && (
          <ListingDetailsChipsWrapper>
            <CustomChip
              label={`${trainingPlanRedux.trainingPlan.frequency}x/week`}
            />
            <CustomChip
              label={`${trainingPlanRedux.trainingPlan.duration} week${
                trainingPlanRedux.trainingPlan?.duration > 1 ? "s" : ""
              }`}
            />
          </ListingDetailsChipsWrapper>
        )}
      </ListingDetailsContentHeader>
      <ListingDetailsContentViewer
        description={trainingPlanRedux.description}
      />
    </ListingDetailsContentWrapper>
  );
};
